import { Box, useTheme } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { LazyImage } from '~/components/LazyImage';
import { CarouselIcon } from '~/components/icons';
import { contentType } from '~/types';
import { hexToRgbaString, isCarouselContent, isVideoAsset } from '~/utils';

const propTypes = {
  alt: PropTypes.string,
  content: contentType,
  contentPreviewedId: PropTypes.string,
};

export const PostPreviewCard = ({
  alt = 'Post preview',
  content: post,
  contentPreviewedId,
  ...props
}) => {
  const theme = useTheme();
  const [asset] = post.assets || [];
  const isVideo = isVideoAsset(asset);

  const isCarousel = isCarouselContent(post);

  const renderIcon = () => {
    if (isCarousel) {
      return (
        <CarouselIcon
          boxSize="24px"
          position="absolute"
          color="white"
          right={{ base: 3, md: 5 }}
          top={{ base: 3, md: 5 }}
          filter={`drop-shadow( 1px 2px 6px ${hexToRgbaString(
            theme.colors.black,
            0.4,
          )}`}
          zIndex="1"
        />
      );
    }
  };

  return (
    <Box
      aria-label="Selected post preview"
      borderRadius="lg"
      overflow="hidden"
      position="relative"
      {...props}
    >
      {renderIcon()}
      <LazyImage
        imageProps={{ alt, id: contentPreviewedId }}
        src={isVideo ? asset?.previewUrl : asset?.url}
      />
    </Box>
  );
};

PostPreviewCard.propTypes = propTypes;
